import { useEffect } from 'react';
import ShopDetailsArea from '../components/shopdetails/ShopDetailsArea';
import ShopDetailsBreadcumb from '../components/shopdetails/ShopDetailsBreadcumb';

function ShopDetailsPage() {
	useEffect(() => {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);
	
  return (
	  <main>
	  <ShopDetailsBreadcumb/>
	  <ShopDetailsArea/>
	  </main>
  )
}
export default ShopDetailsPage;
